module.exports = __webpack_public_path__ + "static/media/Stage-b-f.4f5d612b.webp";